module.exports = __webpack_public_path__ + "img/triangle1yellow.7e146584.png";